define('prevent-doubleclick',['controller', 'elements'], function(controller, elements) {
	function init(context) {
		context.find('button[data-prevent-doubleclick], input[data-prevent-doubleclick]').click(function() {
			var button = $(this);
			// need to defer disabling because otherwise first click will be prevented
			setTimeout(function() {
				button.prop('disabled', true);
				if (button.text()) {
					button.text(button.text() + '...');
				} else if (button.val()) {
					button.val(button.val() + '...');
				}
			});
		});
	}
	
	elements.register(init);
});

